import { Link } from '@tanstack/react-router';

import { cn } from '@/lib/utils';

type TagVariant = 'default' | 'active' | 'outline' | 'muted';

type TagProps = {
  children: React.ReactNode;
  variant?: TagVariant;
  href?: string;
  className?: string;
  onClick?: () => void;
};

const variantClasses: Record<TagVariant, string> = {
  default: 'bg-muted text-muted-foreground hover:bg-muted/60',
  active: 'bg-brand text-primary-foreground',
  outline:
    'border border-brand text-brand hover:bg-brand hover:text-primary-foreground',
  muted:
    'border border-border text-muted-foreground hover:border-brand hover:text-brand',
};

const baseClasses =
  'inline-flex items-center rounded-full px-3 py-0.5 font-mono text-xs font-medium transition-colors';

export const Tag = ({
  children,
  variant = 'default',
  href,
  className,
  onClick,
}: TagProps) => {
  const classes = cn(baseClasses, variantClasses[variant], className);

  if (href) {
    return (
      <Link to={href} className={classes}>
        {children}
      </Link>
    );
  }

  if (onClick) {
    return (
      <button type="button" onClick={onClick} className={classes}>
        {children}
      </button>
    );
  }

  return <span className={classes}>{children}</span>;
};
